export const regex = '^[a-zA-Z0-9]+$';
export default regex;
